// Real, researched competitors in the AI face-analysis / looksmaxxing category.
// Honest comparisons — "where they're strong" and "where Aesthetiq wins".

export const COMPETITORS = [
  {
    slug: "facekit",
    name: "FaceKit",
    platform: "iOS only (TrueDepth)",
    price: "~$7.99/wk after trial",
    tagline: "TrueDepth 3D face scanning app for iPhone.",
    strong: [
      "Genuine TrueDepth depth-sensor 3D scan on supported iPhones",
      "Polished native iOS app with daily routines",
      "Face Battles and shareable FaceCards inside the app",
    ],
    win: [
      "Works in any browser — no App Store download and no iPhone required",
      "Instant first result free, no trial-then-charge paywall",
      "Every result gets a public, indexable share page (real viral loop on the open web)",
      "Transparent flat pricing instead of weekly subscriptions",
    ],
    keywords: ["facekit alternative", "facekit for android", "facekit web version", "facekit without iphone"],
  },
  {
    slug: "umax",
    name: "Umax",
    platform: "iOS / Android",
    price: "~$3.99/wk",
    tagline: "Popular looksmaxxing score app with glow-up tips.",
    strong: [
      "Huge brand recognition in the looksmaxxing space",
      "Simple 1-tap attractiveness score",
      "Trend-driven viral marketing",
    ],
    win: [
      "8 detailed geometric metrics vs a single opaque score",
      "Full AI Coach plan with timeframes, not generic tips",
      "Free web access with no weekly subscription trap",
      "Public share pages + leaderboard for real social proof",
    ],
    keywords: ["umax alternative", "umax free", "apps like umax", "umax vs"],
  },
  {
    slug: "looksmax-ai",
    name: "LooksMax AI",
    platform: "iOS",
    price: "~$6.99/wk",
    tagline: "All-in-one glow-up app for skin, hair and grooming.",
    strong: [
      "Broad glow-up coverage including hairstyles and outfits",
      "Strong App Store ratings",
      "Virtual try-on style previews",
    ],
    win: [
      "No download — start on desktop or mobile web instantly",
      "Objective, repeatable metric scoring you can track over time",
      "Future-Face projection shows your realistic ceiling",
      "Generous free tier without an upfront paywall",
    ],
    keywords: ["looksmax ai alternative", "looksmax ai free", "looksmax ai web", "best looksmax app"],
  },
  {
    slug: "uchad-ai",
    name: "UCHAD AI",
    platform: "Android",
    price: "Freemium + IAP",
    tagline: "Umax-style face rating with jawline and debloat tips.",
    strong: [
      "Android-first audience",
      "Jawline-focused exercise suggestions",
      "Quick attractiveness rating",
    ],
    win: [
      "Cross-platform web — same experience on iOS, Android and desktop",
      "Deeper 8-metric breakdown with notes per metric",
      "Structured multi-week AI Coach plan, not loose tips",
      "Shareable FaceCard with auto-generated branded image",
    ],
    keywords: ["uchad ai alternative", "uchad ai vs", "android face rating app", "looksmax android"],
  },
  {
    slug: "looxup",
    name: "LooxUP",
    platform: "iOS",
    price: "~$4.99/wk",
    tagline: "LooksMax face rating AI with score and advice.",
    strong: [
      "Clean attractiveness rating UI",
      "Actionable improvement suggestions",
      "Lightweight and fast",
    ],
    win: [
      "No subscription required to see your full result",
      "Progress tracking with charts over time (Pro)",
      "Public leaderboard and Face Battles on the open web",
      "Per-result OG images so shares unfurl beautifully",
    ],
    keywords: ["looxup alternative", "looxup vs", "looxup free", "face rating app web"],
  },
  {
    slug: "overchat-looksmax",
    name: "Overchat Looksmax AI",
    platform: "Web + mobile",
    price: "Credit / subscription",
    tagline: "Web looksmax tool with style and glow-up plans.",
    strong: [
      "Already web-based",
      "Covers hair, skin, outfits and style",
      "Detailed category breakdowns",
    ],
    win: [
      "Purpose-built facial-geometry engine, not a general chat add-on",
      "Faster single-purpose flow: upload → result in seconds",
      "Public share pages designed to rank and drive referrals",
      "Flat, predictable pricing without credit metering",
    ],
    keywords: ["overchat looksmax alternative", "looksmax ai online", "web looksmax tool", "free looksmax website"],
  },
  {
    slug: "fotor-pretty-scale",
    name: "Fotor Pretty Scale",
    platform: "Web + app",
    price: "Free / Fotor Pro",
    tagline: "Instant beauty score and symmetry test.",
    strong: [
      "Free and fun beauty score",
      "Part of the broader Fotor editing suite",
      "Quick symmetry read",
    ],
    win: [
      "Real improvement plan instead of a one-off fun score",
      "8 metrics + face shape + percentile, not just a number",
      "Save history and track progress as you improve",
      "Leaderboard and battles for the competitive crowd",
    ],
    keywords: ["pretty scale alternative", "beauty score app", "am i pretty test", "face symmetry test"],
  },
  {
    slug: "pinkmirror",
    name: "PinkMirror",
    platform: "Web",
    price: "Pay per analysis",
    tagline: "Photo beauty analysis and retouching.",
    strong: [
      "Established web beauty-analysis brand",
      "Retouching tools bundled",
      "Detailed facial reports",
    ],
    win: [
      "Free instant scoring with no per-report charge",
      "Modern AI engine with coaching, not just a static report",
      "Built-in virality: share pages, OG cards, leaderboard",
      "Track changes over time rather than one paid snapshot",
    ],
    keywords: ["pinkmirror alternative", "pinkmirror free", "online beauty analysis", "face beauty calculator"],
  },
  {
    slug: "hotness-ai",
    name: "Hotness.ai",
    platform: "Web",
    price: "Freemium",
    tagline: "AI hotness rating from a selfie.",
    strong: [
      "Simple viral hotness rating",
      "Web-based and shareable",
      "Low-friction entry",
    ],
    win: [
      "Constructive, body-positive coaching vs a blunt hotness number",
      "Detailed metric breakdown you can actually act on",
      "Future-Face projection shows what's achievable",
      "Designed for repeat use and progress, not one shock score",
    ],
    keywords: ["hotness ai alternative", "hot or not ai", "ai attractiveness test", "selfie rating ai"],
  },
  {
    slug: "prettyscale",
    name: "PrettyScale.com",
    platform: "Web",
    price: "Free",
    tagline: "Classic 'am I beautiful' measurement test.",
    strong: [
      "Free and widely known",
      "Simple geometric measurement",
      "No signup required",
    ],
    win: [
      "Modern AI analysis instead of fixed manual measurements",
      "Coaching plan + projection, not just a verdict",
      "Save, track and compare results over time",
      "Beautiful shareable cards instead of a plain score",
    ],
    keywords: ["prettyscale alternative", "am i beautiful test", "face beauty test free", "attractiveness calculator"],
  },
  {
    slug: "attractivenesstest",
    name: "AttractivenessTest.com",
    platform: "Web",
    price: "Free / Pro report",
    tagline: "Detailed attractiveness percentile report.",
    strong: [
      "Percentile-based scoring",
      "Detailed written report",
      "Research-flavoured framing",
    ],
    win: [
      "Actionable AI Coach plan, not just a diagnosis",
      "Faster, cleaner flow with a modern UI",
      "Social features: leaderboard, battles, share pages",
      "Free core result without a paid report upsell",
    ],
    keywords: ["attractiveness test alternative", "attractiveness percentile", "how attractive am i", "facial attractiveness test"],
  },
  {
    slug: "face-ai-analysis-app",
    name: "Face AI Analysis App",
    platform: "iOS",
    price: "Subscription",
    tagline: "AI facial mapping with a 1-10 beauty score.",
    strong: [
      "Golden-ratio focused scoring",
      "Clean native iOS experience",
      "Symmetry and proportion read",
    ],
    win: [
      "No download and no iOS requirement",
      "100-point scale with 8 metrics for finer detail",
      "Coaching + projection + progress tracking",
      "Open-web share pages that actually rank and refer",
    ],
    keywords: ["face ai analysis alternative", "face analysis app web", "golden ratio face app", "ai beauty score web"],
  },
];

export const bySlug = (slug) => COMPETITORS.find((c) => c.slug === slug);
